import React from 'react';
import Grid from '@material-ui/core/Grid'
import {
    AutocompleteArrayInput,
    BooleanInput,
    CheckboxGroupInput,
    DateInput,
    LongTextInput,
    ReferenceArrayInput,
    required,
    TextInput
} from 'react-admin';
import {schoolYears, TreeCheckboxInput} from "../../components";

const PollFields = props => (
    <React.Fragment>

        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="title"
                           validate={required()}  {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="description" {...props} />
        </Grid>

        <Grid item xs={12} sm={6} style={{width: '90%'}}>
            <ReferenceArrayInput
                validate={required()}
                label="resources.polls.fields.questionGroupIds"
                source="questionGroupIds"
                reference="questionGroups" {...props}>
                <AutocompleteArrayInput optionText={"title"}/>
            </ReferenceArrayInput>
        </Grid>
        <Grid item xs={12} sm={6}>
            <BooleanInput source="display" {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <DateInput source="startDate" style={{width: '50%'}}
                       label="resources.polls.fields.startDate"
                       validate={required()}/>
        </Grid>

        <Grid item xs={12} sm={6}>
            <TextInput type="time" style={{width: '50%'}}
                       source="startTime"
                       validate={required()}
                       label="resources.polls.fields.startTime"/>
        </Grid>
        <Grid item xs={12} sm={6}>
            <DateInput source="endDate" style={{width: '50%'}}
                       validate={required()}
                       label="resources.polls.fields.endDate"/>
        </Grid>

        <Grid item xs={12} sm={6}>
            <TextInput type="time" style={{width: '50%'}}
                       source="endTime"
                       validate={required()}
                       label="resources.polls.fields.endTime"/>
        </Grid>

        <Grid item xs={12} sm={6}>
            <label>Danh sách lớp *</label>
            <div style={{maxHeight: '350px', overflow: 'auto'}}>
                <ReferenceArrayInput source="unitIds" reference="baseUnits"
                                     filter={{schoolYearId: schoolYears.length > 0 ? schoolYears[0].id : ''}}
                                     perPage={999} {...props} >
                    <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                </ReferenceArrayInput>
            </div>
        </Grid>
        <Grid item xs={12} sm={6}>
            <div style={{maxHeight: '350px', overflow: 'auto'}}>
                <ReferenceArrayInput
                    label="resources.polls.fields.deviceIds"
                    source="deviceIds"
                    reference="accessDevices" {...props}>
                    <CheckboxGroupInput/>
                </ReferenceArrayInput>
            </div>
        </Grid>
    </React.Fragment>
)

export default PollFields
